import { createSlice } from '@reduxjs/toolkit';

/**
 * Real-time AI video generation progress pushed by Core via SignalR
 * (NotificationHub → receiveVideoProgress, fed by the VideoWorker service).
 * Keyed by videoId: { progress, step, status, message }.
 */
const videoProgressSlice = createSlice({
  name: 'videoProgress',
  initialState: {
    byId: {},
  },
  reducers: {
    videoProgressUpdate(state, { payload }) {
      if (!payload?.videoId) return;
      state.byId[payload.videoId] = {
        progress: payload.progress ?? 0,
        step: payload.step ?? '',
        status: payload.status ?? '',
        message: payload.message ?? '',
      };
    },
    videoProgressClear(state, { payload: videoId }) {
      delete state.byId[videoId];
    },
  },
});

export const { videoProgressUpdate, videoProgressClear } = videoProgressSlice.actions;

export const selectVideoProgressById = (state) => state.videoProgress.byId;

export default videoProgressSlice.reducer;
